<mat-dialog-content>
  <mat-icon class="main-icon" svgIcon="verified_user"></mat-icon>
  <div class="text">
    <h2 i18n="@@consent.title">Your Privacy Matters to Us</h2>
    <p i18n="@@consent.text">
      We use cookies and similar technologies to analyze how our website is used and
      to improve our services. For this purpose, we use Google Analytics.
      <br /><br />
      Google Analytics will only be used with your consent. You can withdraw or modify
      your choice at any time via the "Cookie Settings" link.
    </p>
    @if (accepted !== null) {
      @if (accepted) {
        <div class="current-state accepted">
          <mat-icon svgIcon="check"></mat-icon>
          <span i18n="@@consent.state.accepted">Google Analytics is accepted.</span>
        </div>
      } @else {
        <div class="current-state rejected">
          <mat-icon svgIcon="close"></mat-icon>
          <span i18n="@@consent.state.rejected">Google Analytics is rejected.</span>
        </div>
      }
    }
    <div class="links">
      <button mat-button type="button" (click)="openDetails()" i18n="@@consent.details.label">Details</button>
      <a mat-button [href]="privacyPolicyUrl" target="_blank" rel="noopener" i18n="@@consent.privacy.label">Privacy Policy</a>
      <a mat-button [href]="imprintUrl" target="_blank" rel="noopener" i18n="@@consent.imprint.label">Imprint</a>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button type="button" class="action" [mat-dialog-close]="false" i18n="@@consent.rejectAll.label">Reject all</button>
  <button mat-button type="button" class="action action--primary" [mat-dialog-close]="true" cdkFocusInitial i18n="@@consent.acceptAll.label">Accept all</button>
</mat-dialog-actions>
